/* eslint-disable no-restricted-globals */
/**
 * @description
 */

/* global bsBreakpoints ModuloTS polyfillsIE */

(() => {
	// VARS
	const form = {
		allInputFile: document.querySelectorAll('input[type=file]'),
		allInputRange: document.querySelectorAll(
			'input[type=range]:not([data-plyr])'
		),
		allSelect: document.querySelectorAll(`select`),
		allLikertInput: document.querySelectorAll(
			'.webform-likert-table-wrapper input[type=radio]'
		),
		allLikertWrapper: document.querySelectorAll(
			'.webform-likert-table-wrapper table'
		),
	};

	const breakpoint = bsBreakpoints.detectBreakpoint();

	/**
	 * @description
	 * Mise en col bootstrap
	 */
	const DispoBoot = () => {
		const progressBar = document.querySelectorAll('.webform-progress');

		for (let i = 0; i < progressBar.length; i += 1) {
			const InitialForm = progressBar[i].parentNode.children;
			for (let y = 0; y < InitialForm.length; y += 1) {
				if (InitialForm[y].classList.contains('webform-elements')) {
					InitialForm[y].classList.add(
						'col-lg-8',
						'offset-lg-1',
						'col-sm-12'
					);
				}
				if (InitialForm[y].classList.contains('form-actions')) {
					InitialForm[y].classList.add('col-lg-9', 'col-sm-12');
				}
			}
		}
	};
	/**
	 * @description
	 * Custom input file
	 */
	const inputOveride = () => {
		form.allInputFile.forEach((el) => {
			const fileLabel = el.getAttribute('id');
			el.insertAdjacentHTML(
				`beforebegin`,
				`<label for="${fileLabel}" class="custom__input-file">
		  <span class="custom__input-file__button">
		  ${ModuloTS['choose a file']} <i data-icon="download"></i>
		  </span>
		</label>`
			);
		});
	};
	/**
	 * @description
	 * Afficher/Masquer mdp
	 */
	const showPassword = () => {
		document
			.querySelectorAll('input[type=password]')
			.forEach((inputPass) => {
				const text = inputPass.classList.contains('password-confirm')
					? 'confirmation password'
					: 'password';
				inputPass.insertAdjacentHTML(
					'afterend',
					`<div class="inputPassShow">
						<button type="button" data-pwd="show"><i data-icon="password"> </i>${
							ModuloTS[`Show ${text}`]
						}</button>
						${inputPass.outerHTML}
					</div>`
				);
				inputPass.remove();
			});
		document.querySelectorAll('.inputPassShow').forEach((customPass) => {
			customPass
				.querySelector('button')
				.addEventListener('click', (event) => {
					event.stopImmediatePropagation();
					event.preventDefault();
					const input = customPass.querySelector('input');
					const btn = customPass.querySelector('button');
					const pwd = btn.getAttribute('data-pwd');
					const text = input.classList.contains('password-confirm')
						? 'confirmation password'
						: 'password';
					if (pwd === 'show') {
						// eslint-disable-next-line no-param-reassign
						btn.innerHTML = `<i data-icon="password"> </i> ${
							ModuloTS[`Hide ${text}`]
						}`;
						input.setAttribute('type', 'text');
						btn.setAttribute('data-pwd', 'hide');
					} else {
						// eslint-disable-next-line no-param-reassign
						btn.innerHTML = `<i data-icon="password"> </i> ${
							ModuloTS[`Show ${text}`]
						}`;
						input.setAttribute('type', 'password');
						btn.setAttribute('data-pwd', 'show');
					}
				});

			if (
				document.body.contains(
					document.querySelector('.user-login-form')
				)
			) {
				// submit form when 'Enter' key is pressed
				customPass
					.querySelector('input')
					.addEventListener('keyup', function (event) {
						if (event.keyCode === 13) {
							document.querySelector('.user-login-form').submit();
						}
					});
			}
		});
	};
	/**
	 * @description
	 * Attr Title sur les tableaux
	 */
	const likertWrapper = () => {
		form.allLikertWrapper.forEach((wrap) => {
			wrap.querySelectorAll('thead th').forEach((el) => {
				el.setAttribute('scope', 'col');
			});

			wrap.querySelectorAll('tbody th').forEach((el) => {
				el.setAttribute('scope', 'row');
			});
		});
	};

	/**
	 * @description
	 * Custom input number avec button + et -
	 */
	const numberInput = () => {
		document.querySelectorAll('.js-form-type-number').forEach((el) => {
			let inputLabelId;

			el.querySelectorAll('input').forEach((input) => {
				const inputId = input.getAttribute('id') || null;

				input.insertAdjacentHTML(
					'afterend',
					`<div class="custom__input-number">
              			<button class="custom__input-number__button--less" aria-describedby="${inputId}">
			  				<span aria-hidden="true">-</span>
							<span class="sr-only">${ModuloTS.Decrease}</span>
			  			</button>
              			<span class="custom__input-number__data">${input.outerHTML}</span>
              			<button class="custom__input-number__button--plus" aria-describedby="${inputId}">
							<span aria-hidden="true">+</span>
							<span class="sr-only">${ModuloTS.Increase}</span>
			  			</button>
         			 </div>`
				);
				inputLabelId = inputId;

				input.remove();
			});

			// el.querySelector('label').setAttribute('id', inputLabelId);

			document
				.querySelectorAll('.custom__input-number__data input')
				.forEach((input) => {
					input.value = 0;
				});
			el.querySelectorAll('button').forEach((button) => {
				button.addEventListener('click', (event) => {
					event.preventDefault();
					el.querySelectorAll('input').forEach((input) => {
						if (
							button.getAttribute('class') ===
							'custom__input-number__button--plus'
						) {
							// eslint-disable-next-line no-plusplus
							// eslint-disable-next-line no-param-reassign
							input.value++;
						} else {
							input.value--;
						}
					});
				});
			});
		});
	};
	/**
	 * @description
	 * Barres de couleur pour la force des mdp
	 */
	const passwordBarStrength = () => {
		document
			.querySelectorAll('.inputPassShow .password-field')
			.forEach((el) => {
				el.insertAdjacentHTML(
					'afterend',
					`<div class='password-status'>
            <div class="password-status__bars"></div>
            <div class="password-status__bars"></div>
            <div class="password-status__bars"></div>
            <span aria-live="polite" aria-atomic="true" class="password-strength__text js-password-strength__text password-test__message" id="passStrength"></span>
        </div>`
				);

				// construction du mutation observer
				const config = {
					attributes: true,
					childList: true,
					subtree: true,
				};
				const targetNode = document.getElementById('passStrength');

				// Remplir de couleur ou non
				const RemoveBarColor = (number) => {
					document
						.querySelector(
							`.password-status div:nth-child(${number})`
						)
						.classList.remove(
							`password-status__bars--lvl${number}`
						);
				};
				const AddBarColor = (number) => {
					document
						.querySelector(
							`.password-status div:nth-child(${number})`
						)
						.classList.add(`password-status__bars--lvl${number}`);
				};

				// Condition pour afficher couleurs des barres ou non
				document
					.querySelectorAll('.inputPassShow .password-field')
					.forEach((el) => {
						el.addEventListener('input', (event) => {
							const mutationObserver = new MutationObserver(
								(mutations) => {
									mutations.forEach((mutation) => {
										if (event.target.value === '') {
											// eslint-disable-next-line no-param-reassign
											mutation.target.innerText = '';
											RemoveBarColor(1);
											RemoveBarColor(2);
											RemoveBarColor(3);
										}
										if (
											mutation.target.innerText ===
											'Faible'
										) {
											AddBarColor(1);
											RemoveBarColor(2);
											RemoveBarColor(3);
										}
										if (
											mutation.target.innerText ===
												'Correct' ||
											mutation.target.innerText === 'Bien'
										) {
											AddBarColor(1);
											AddBarColor(2);
											RemoveBarColor(3);
										}
										if (
											mutation.target.innerText === 'Fort'
										) {
											AddBarColor(1);
											AddBarColor(2);
											AddBarColor(3);
										}
									});
								}
							);
							mutationObserver.observe(targetNode, config);
						});
					});
			});
	};

	/**
	 * @description
	 * Gestion des checbox/radio en inline
	 */
	const hideLabelInline = () => {
		document.querySelectorAll('.container-inline').forEach((el) => {
			el.querySelectorAll('.form__label').forEach((label) => {
				label.remove();
			});
		});
		document
			.querySelectorAll('.js-form-type-radio .form__label')
			.forEach((radio) => {
				radio.classList.add('custom__label');
			});
		document
			.querySelectorAll('.js-form-type-checkbox .form__label')
			.forEach((radio) => {
				radio.classList.add('custom__label');
			});
	};
	/**
	 * @description
	 * Gestion de l'input sur les checkbox 'autre valeur' & gestion des placeholder
	 */
	const otherValue = () => {
		document.querySelectorAll('input[type=text]').forEach((input) => {
			if (
				input.getAttribute('placeholder') ===
				`${ModuloTS['Type an other value']}...`
			) {
				input.classList.add('custom__other-value');
				input.setAttribute(
					'title',
					`${ModuloTS['Type an other value']}...`
				);
			}
		});
	};

	/**
	 * @description
	 * Gestion de l'affichage des aides sur les inputs
	 */
	const labelHelper = () => {
		document.querySelectorAll('.form__label__helper').forEach((el) => {
			let helpCore = `<div class="custom__help-box">`;
			const helper = el.getAttribute('data-webform-help');
			helpCore += helper;
			helpCore += `</div>`;
			el.insertAdjacentHTML('beforebegin', helpCore);
		});
	};

	/**
	 * @description
	 * Gestion du sticky sous input range
	 */
	const setSliderLabel = (
		rangeInput,
		suffix,
		minValue,
		maxValue,
		labelWidth
	) => {
		// Insert la valeur du label
		rangeInput.parentNode.lastElementChild.innerHTML = `${rangeInput.value} ${suffix}<hr>`;

		// Calcul position curseur
		const halfThumbWidth = 20 / 2;
		let halfLabelWidth;
		rangeInput.parentNode.lastElementChild.offsetWidth / 2 === 0
			? (halfLabelWidth = 30)
			: (halfLabelWidth =
					rangeInput.parentNode.lastElementChild.offsetWidth / 2);
		const sliderWidth = rangeInput.offsetWidth;
		const centerPosition = sliderWidth / 2;
		let percentOfRange =
			(rangeInput.value - minValue) / (maxValue - minValue);

		if (isNaN(percentOfRange)) {
			percentOfRange = 0;
		}

		const valuePxPosition = percentOfRange * sliderWidth;
		const distFromCenter = valuePxPosition - centerPosition;
		const percentDistFormCenter = distFromCenter / centerPosition;
		const offset = percentDistFormCenter * halfThumbWidth;

		const finalLabelPosition = valuePxPosition - halfLabelWidth - offset;
		rangeInput.parentNode.lastElementChild.setAttribute(
			'style',
			`width: ${labelWidth}px; left: ${finalLabelPosition}px; top:50px;`
		);
	};

	/**
	 * @description
	 * Gestion de l'input range
	 */
	const customRange = () => {
		createCustomRangeA11Y();
		form.allInputRange.forEach((el) => {
			const minValue = el.getAttribute('min');
			const maxValue = el.getAttribute('max');
			const dataRangeValue =
				document.querySelector('[data-range-value]') || null;
			el.setAttribute('step', 1);
			const hasSuffix =
				document.querySelector('.field-suffix .field-suffix') || null;
			let suffix = '€';

			if (hasSuffix) {
				suffix = document.querySelector(
					'.field-suffix .field-suffix'
				).innerText;
			}

			const interval = document.createElement('div');
			interval.classList.add(
				'range-interval',
				'd-flex',
				'justify-content-between'
			);
			interval.innerHTML = `<div>${minValue} ${suffix}</div><div>${maxValue} ${suffix}</div>`;

			const stickyLabel = `<span class="sticky-range">${maxValue} ${suffix}</span>`;

			el.parentNode.insertBefore(interval, el);
			el.insertAdjacentHTML('afterend', stickyLabel);

			// Taille maximum du sticky
			const labelWidth = el.parentNode.lastElementChild.offsetWidth;
			el.parentNode.lastElementChild.setAttribute(
				'style',
				'display: none;'
			);

			el.addEventListener('input', () => {
				setSliderLabel(el, suffix, minValue, maxValue, labelWidth);
				dataRangeValue.innerHTML = el.value;
				updateCustomRangeA11Y(el);
			});

			el.addEventListener('focusout', () => {
				// el.parentNode.lastElementChild.setAttribute('style', 'display: none;');
			});
		});
	};

	/**
	 * @description création d'alternative au drag range pour l'A11Y
	 */
	const createCustomRangeA11Y = () => {
		const allRanges = document.querySelectorAll('.form__item-intervalle');
		allRanges.forEach((range) => {
			const el = range.querySelector('input[type="range"]');
			const inputRangeId = el.getAttribute('id') || null;
			const getRangeValue = range.querySelector(
				'input[type="range"]'
			).valueAsNumber;
			const addBlocA11Y = `
			<div class="form__item-intervalle__input-container">
			<button ${
				inputRangeId ? `aria-describedby="${inputRangeId}"` : ''
			} data-btn-range-decrease>
			<span aria-hidden="true">-</span>
			<span class="sr-only">${ModuloTS.Decrease}</span>
			</button>
			<span data-range-value class="form__item-intervalle__input-number">${getRangeValue}</span>
			<button ${
				inputRangeId ? `aria-describedby="${inputRangeId}"` : ''
			}data-btn-range-increase>
			<span aria-hidden="true">+</span>
			<span class="sr-only">${ModuloTS.Increase}</span>
			</button>
			</div>`;
			range.insertAdjacentHTML('beforeend', addBlocA11Y);

			const minValue = el.getAttribute('min');
			const maxValue = el.getAttribute('max');
			const labelWidth = 60;
			const wrapperInput = document.querySelector(
				'.form__item-intervalle__input-container'
			);
			const rangeBtns = wrapperInput.querySelectorAll('button');
			rangeBtns.forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.preventDefault();
					if (btn.getAttribute('data-btn-range-decrease') != null) {
						el.stepDown();
					} else {
						el.stepUp();
					}
					document.querySelector('[data-range-value]').innerHTML =
						el.value;
					setSliderLabel(el, '€', minValue, maxValue, labelWidth);
				});
			});
		});
	};

	/**
	 * @description return suffix
	 */
	const returnSufix = (el) => {
		const hasSuffix =
			document.querySelector('.field-suffix .field-suffix') || null;

		let suffix = '€';
		if (hasSuffix) {
			suffix = document.querySelector(
				'.field-suffix .field-suffix'
			).innerText;
		}
		return suffix;
	};

	/**
	 * @description mise à jour de la value de l'input number avec la value de l'input range associé
	 */
	const updateCustomRangeA11Y = (range) => {
		const getNumber = range.parentNode.parentNode.querySelector(
			'input[type="number"]'
		);
		getNumber.value = range.value;
	};

	const insertInputMaxValue = () => {
		document.querySelectorAll('.range-interval').forEach((range) => {
			range.insertAdjacentHTML(
				'afterbegin',
				'<div class="custom__range__max-value-cursor"></div>'
			);
		});
	};

	// eslint-disable-next-line no-unused-vars
	const toutDeplier = () => {
		document.querySelectorAll(`[data-webform-key]`).forEach((page) => {
			if (page.getAttribute(`data-webform-key`) === 'page_1') {
				if (page.childElementCount > 15) {
					const formLimit =
						page.querySelectorAll(`div.form-group`)[15].offsetTop;
					const pageHeight = page.offsetHeight;
					if (pageHeight >= formLimit) {
						page.setAttribute(
							'style',
							`height: ${formLimit}px; overflow:hidden; max-height: ${formLimit}px;`
						);
					}

					page.insertAdjacentHTML(
						'beforeend',
						`<div class="toggle-switch" data-show="hide">
              <div class="toggle-switch__button"></div>
              <button class="toggle-switch__switch" id="hide">
                ${ModuloTS.Fold}
              </button>
              <button class="toggle-switch__switch" id="show">
                ${ModuloTS.Unfold}
              </button>
            </div>`
					);

					document
						.querySelectorAll('.toggle-switch__switch')
						.forEach((toggle) => {
							toggle.addEventListener('click', (event) => {
								event.preventDefault();

								if (
									document
										.querySelector('.toggle-switch')
										.getAttribute('data-show') === 'hide' &&
									toggle.getAttribute('id') === 'show'
								) {
									document
										.querySelector('.toggle-switch')
										.setAttribute('data-show', 'show');
									document
										.querySelector(`[data-webform-key]`)
										.setAttribute(
											'style',
											`height: ${pageHeight}px; overflow:hidden; max-height: ${pageHeight}px;`
										);
								}

								if (
									document
										.querySelector('.toggle-switch')
										.getAttribute('data-show') === 'show' &&
									toggle.getAttribute('id') === 'hide'
								) {
									window.scrollTo(0, 0);
									document
										.querySelector('.toggle-switch')
										.setAttribute('data-show', 'hide');
									document
										.querySelector(`[data-webform-key]`)
										.setAttribute(
											'style',
											`height: ${formLimit}px; overflow:hidden; max-height: ${formLimit}px;`
										);
								}
							});
						});
				}
			}
		});
	};

	const userFormTitle = () => {
		const userFormTitle = document.querySelector('.user-form__title');
		const userForm = document.querySelector('.user-login-form');
		if (userFormTitle) {
			userForm.insertAdjacentElement('afterbegin', userFormTitle);
		}
	};

	const redStars = () => {
		document
			.querySelectorAll('span.webform-element-help')
			.forEach((help) => {
				help.insertAdjacentHTML(
					'beforebegin',
					`<span class="red-start">*</span>`
				);
			});
	};

	const legendHidden = () => {
		document
			.querySelectorAll('fieldset legend')
			.forEach((hiddenContent) => {
				hiddenContent
					.querySelectorAll('.visually-hidden')
					.forEach((element) => {
						if (element !== null) {
							element.classList.add('content-hiddden');
							hiddenContent.classList.add('content-hiddden');
						}
					});
			});
	};

	const stepButton = () => {
		const stepButton = document.querySelector('.webform-button--next');
		if (stepButton !== null && stepButton !== undefined) {
			stepButton.insertAdjacentHTML(
				'afterend',
				`<div class="step-button">${stepButton.outerHTML}</div>`
			);
			stepButton.remove();
			document
				.querySelector('.step-button')
				.insertAdjacentHTML('afterbegin', '<i data-icon="arrow"></i>');
		}
	};

	const loginForm = () => {
		const loginFormRoot = document.querySelector('.user-login-form');
		const bannerTitle =
			document.querySelector('.banner > div > div > div > div > h1') ||
			null;

		if (document.body.contains(loginFormRoot)) {
			loginFormRoot.classList.add('module');

			if (bannerTitle) {
				bannerTitle.style.textAlign = 'center';
				bannerTitle.style.borderBottom = '1px solid #EFF3F8';
			}

			if (window.matchMedia('(min-width: 500px)').matches) {
				bannerTitle.style.paddingBottom = '50px';
			} else {
				bannerTitle.style.paddingBottom = '30px';
			}
		}
	};

	const summaryAndProgress = () => {
		if (
			document.body.contains(
				document.querySelector('.webform-progress') &&
					document.querySelector('.page-summary-card')
			)
		) {
			const progress = document.querySelector('.webform-progress');
			// Obtient une référence à l'élément avant lequel nous voulons insérer
			const summaryEl = document.querySelector('.page-summary-card');
			// Obtient une référence à l'élément parent
			const summaryParent = summaryEl.parentNode;
			summaryParent.insertBefore(progress, summaryEl.nextSibling);
			progress.classList.add('side');
		}
	};
	/**
	 * @description Ajouter tag p en amont du form pour expliciter le * des champs obligatoires
	 */
	const a11yForm = () => {
		const allForms = document.querySelectorAll('.webform-submission-form');
		allForms.forEach((form) => {
			// Ajout d'un <p> en amont du form pour expliciter les *
			const txt = `<p class="msg-required">${ModuloTS['Fields followed by * are required']}</p>`;
			form.insertAdjacentHTML('afterbegin', txt);
		});
		const allDescriptions = document.querySelectorAll(
			'.webform-element-description'
		);
		allDescriptions.forEach((description) => {
			// Ajout d'une balise sémantique
			const oldHtml = description.innerHTML;
			const newHtml = `<p>${oldHtml}</p>`;
			description.innerHTML = newHtml;
		});

		inputFileInfos();
		srOnlytelephone();
	};

	/**
	 * @description
	 * Gestion des informations à propos d'un input de type file a11y
	 */

	const inputFileInfos = () => {
		const inputFile =
			document.querySelector('#edit-fichier-upload') || null;
		const inputFileDesc =
			document.querySelector('#edit-fichier--description') || null;

		if (inputFileDesc && inputFile) {
			inputFile.setAttribute('aria-describedby', inputFileDesc.id);
		}
	};

	const srOnlytelephone = () => {
		const formTel =
			document.querySelectorAll(
				'.js-form-item-telephone .iti__selected-flag'
			) || null;
		if (formTel) {
			formTel.forEach((tel) => {
				tel.insertAdjacentHTML(
					'beforeend',
					`<span class="sr-only"> ${ModuloTS['Telephone code']} <span>`
				);
			});
		}
	};

	const init = () => {
		polyfillsIE();
		DispoBoot();
		// inputOveride();
		customRange();
		showPassword();
		likertWrapper();
		numberInput();
		hideLabelInline();
		otherValue();
		labelHelper();
		passwordBarStrength();
		insertInputMaxValue();
		redStars();
		legendHidden();
		stepButton();
		loginForm();
		userFormTitle();

		document.addEventListener('DOMContentLoaded', () => {
			a11yForm();
			bsBreakpoints.init();

			if (breakpoint === 'xLarge' || breakpoint === 'large') {
				summaryAndProgress();

				window.onresize = function () {
					summaryAndProgress();
				};
			}
		});
	};

	init();
})();
